import script from "./UploadOptionList.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadOptionList.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/pc/upload.css?vue&type=style&index=0&id=5b532b2e&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b532b2e"]])

export default __exports__